import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  /** Announced to screen readers (no visible caption). */
  @Input() label = 'Loading';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  /** Compact layout for nested sections (e.g. challenge ideas list). */
  @Input() inline = false;
}
